// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__Ovlii","statsList":"styles_statsList__4t-4C"};